module.exports = __webpack_public_path__ + "static/img/tt-2.f9e69e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/tiktok/tt-2.png
// module id = j5aH
// module chunks = 46